import { ActionTree } from "vuex";
import * as types from "@/store/constants/types";
import store from "@/store";
import { casino, redeem } from "@/api/http/gx/gxUser";
import Http from "@/api/http/fetch/index";
import EventBus from "@/utils/eventBus";
import dialogCountDownTime from "@/views/casino/megabucks/dialogCountDown";
import { type } from "os";
import {getAppVersion, isIos} from "@/utils/lodash";
import {judgeVersion} from "@/utils/judgeVersion";

const actions: ActionTree<any, any> = {
  async [types.REQUEST_CASINO]({ state, commit, dispatch, getters }, payload: any) {
    try {
      const { way, game } = payload;
      const masterId = getters[types.GETTER_MASTER_ID];
      const result: any = await casino(masterId, way, game);
      console.log("REQUEST_CASINO result:", result);
      if (result.user_info) {
        commit(types.RECEIVE_GX_MASTER_SERVER_DATA, result.user_info);
      }
      return result;
    } catch (error) {
      console.log("REQUEST_CASINO error:", error);
      return Promise.reject(error);
    }
  },

  async [types.WATCH_CASINO_VIDEO]({ state, commit, dispatch, getters }, payload: any) {
    try {
      const way: string = payload;
      let requestData: any;

      if (isIos()) {
        requestData = "casino"
      } else {
        const userAgent = getAppVersion();
        requestData = judgeVersion(userAgent, "4.0.0") ? {reward: false, admob_enabled: true} : "casino";
      }
      const result: any = await Http.IsVideoAvailable(requestData);
      if (result === "1" || result === "true") {
        const playVideoResult: any = await Http.PlayVideo(requestData);
        console.log("playVideoResult:", playVideoResult);
        if (playVideoResult && playVideoResult.status === "fail") {
          let content = "";
          if (way === "ad") {
            return;
          } else if (way === "double") {
            content = "Double chance cancelled!";
          } else if (way === "extra") {
            content = "Extra chance cancelled!";
          } else if (way === "free") {
            content = "Free chance cancelled!";
          }
          EventBus.$emit("toast-show", {
            type: "warning",
            content
          });
          return Promise.reject(playVideoResult.error);
        }
        return playVideoResult;
      } else {
        EventBus.$emit("toast-show", {
          type: "warning",
          content: "Video is not ready yet"
        });
        console.log("IsVideoAvailable false");
        return Promise.reject("IsVideoAvailable false");
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async [types.REDEEM_REWARD]({ state, commit, dispatch, getters }, payload: any) {
    try {
      EventBus.$emit("toast-show", {
        type: "loading",
        content: "processing…",
        duration: "infinite"
      });
      console.log("REDEEM_REWARD payload:", payload);
      const { token, double, reward } = payload;
      const masterId = getters[types.GETTER_MASTER_ID];
      const result: any = await redeem(masterId, token, double);
      console.log("REDEEM_REWARD result:", result);
      commit(types.RECEIVE_GX_MASTER_SERVER_DATA, result);
      EventBus.$emit("toast-hide");
      EventBus.$emit("toast-show", {
        type: "get-coins",
        way: "normal",
        coins: reward.reward * (double === true ? 2 : 1),
        duration: 2000
      });
      return result;
    } catch (error) {
      //购买失败
      EventBus.$emit("toast-hide");
      return Promise.reject(error);
    }
  },

  /**
   *
   * @param free
   * @param deadline
   * @param cost
   * @param freeAction
   *
   */
  async [types.ACTION_SHOW_OUT_OF_COIN_DIALOG]({ state, commit, dispatch, getters }, payload: any) {
    const { free, deadline, cost, freeAction } = payload; // 免费机会，下次免费机会时间戳，需要的金币
    const userCoins = getters[types.GETTER_MASTER_COINS];

    //金币不足的弹窗：
    let buttons;
    let bottomContent;
    if (free) {
      //还有免费的机会
      buttons = [
        {
          text: "FREE TRY",
          leftIcon: require("@/assets/icons-file/casino/ico_casino_popup_freetry@3x.png"),
          bgColor: "linear-gradient(to right, rgb(255,117,111), rgb(255,58,81)",
          fontFamily: "WorkSans-SemiBold,AppleSDGothicNeo-Bold",
          clickFn: () => {
            freeAction === undefined ? null : freeAction();
          }
        },
        {
          text: "GET COINS",
          clickFn: () => {
            dispatch(types.ROUTER_PUSH, {
              name: "CoinsStore",
              params: {
                routerTransition: "up"
              }
            });
          }
        }
      ];
    } else {
      //没有免费的机会
      buttons = [
        {
          text: "GET COINS",
          bgColor: "linear-gradient(to right, rgb(255,117,111), rgb(255,58,81)",
          fontFamily: "WorkSans-SemiBold,AppleSDGothicNeo-Bold",
          clickFn: () => {
            dispatch(types.ROUTER_PUSH, {
              name: "CoinsStore",
              params: {
                routerTransition: "up"
              }
            });
          }
        }
      ];
      bottomContent = dialogCountDownTime(deadline ? deadline : new Date().valueOf() + 86400000);
    }
    dispatch(types.DIALOG_SHOW, {
      title: "Out of Coins!",
      topIcon: require("@/assets/icons-file/casino/pic_casino_popup_ads@3x.png"),
      midContent: `Need <i>${cost}</i> coins, you only have ${userCoins} coins. Would you like to get more coins?`,
      buttons,
      bottomContent
    });
  }
};

export default actions;
